import React from 'react';
import Link from '../link';
import DataTableActionButton from './DataTableActionButton';

function DataTableActionMenu (
  props = {
    options: [
      {
        iconName: 'fa-regular fa-trash-can',
        onClick: () => alert('Please define onClick function for DataTableActionMenu option'),
        text: 'Menu sample text',
        roleKey: undefined,
        tooltipText: undefined,
      },
    ],
  }
)
{
  const options = props.options.sort((a, b) =>
  {
    if (!a || !b) return 0;
    return a.url && !b.url ? 1 : !a.url && b.url ? -1 : 0;
  });
  return (
    <div key='dtmamdivkey'>
      {options.map((o, index) =>
      {
        if (!o || o.hide || (typeof o.hide === 'function' && o.hide())) return null;
        if (o.separator)
          return (
            <div
              className='border'
              key={`dtamsp${index}`}
            />
          );
        if (o.link)
        {
          return (
            <Link
              linktext={o.linktext}
              withoutText={o.withoutText}
              title={o.title ? o.title : o.text}
              link={o.link}
              iconName={o.iconName}
              tooltipText={o.tooltipText}
              dropdownmenu={true}
              url={o.url}
              text={o.text}
              key={`dtaml${index}`}
            />
          );
        }

        return (
          <DataTableActionButton
            className={o.className}
            innerClassName={o.innerClassName}
            iconName={o.iconName}
            onClick={o.onClick}
            text={o.text}
            roleKey={o.roleKey}
            tooltipText={o.tooltipText}
            disabled={o.disabled}
            key={`dtamo${index}`}
            url={o.url}
            target={o.target}
            rel={o.rel}
            isMarkedRed={o.isMarkedRed}
          />
        );
      })}
    </div>
  );
}

export default DataTableActionMenu;
